// src/router/index.js
<link
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css"
  rel="stylesheet"
/>

import { createRouter, createWebHistory } from "vue-router";
//import jwt from 'jsonwebtoken' // Use the same library to verify tokens

import LoginPage from "../components/LoginPage.vue";
import HomePage from "../components/HomePage.vue";
import CustomersPage from "../components/CustomersPage.vue";
import ItemsPage from "../components/ItemsPage.vue";
import AddCustomerPage from "../components/AddCustomerPage.vue";
import AddItemPage from "../components/AddItemPage.vue";
import AddQuotePage from "@/components/AddQuotePage.vue";
import QuotesPage from "@/components/QuotesPage.vue";

const routes = [
  { 
    path: "/", 
    component: LoginPage 
  },

  { 
    path: "/home", 
    component: HomePage, 
    meta: { requiresAuth: true } 
  },

  {
    path: "/customers",
    component: CustomersPage,
    meta: { requiresAuth: true },
  },

  {
    path: "/add-customer",
    component: AddCustomerPage,
    meta: { requiresAuth: true },
  },

  { 
    path: "/items", 
    component: ItemsPage, 
    meta: { requiresAuth: true } 
  },

  { 
    path: "/add-item", 
    component: AddItemPage, 
    meta: { requiresAuth: true } 
  },

  { 
    path: "/quotes", 
    component: QuotesPage, 
    meta: { requiresAuth: true } 
  },
  
  { 
    path: "/add-quote", 
    component: AddQuotePage, 
    meta: { requiresAuth: true } 
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Route guard to check for JWT
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        // Verify token
        //jwt.verify(token, 'secret_key').. TODO server
        if (token.length > 0) {
          next();
        }
      } catch (err) {
        alert("Session expired. Please log in again.");
        localStorage.removeItem("token");
        next("/");
      }
    } else {
      //alert("You need to log in first!");
      next("/");
    }
  } else {
    next();
  }
});

export default router;
